var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlert)?_c('div',{staticClass:"ba-alert ba-error"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('be-alert-to-send-sms'))+". "),_c('b-link',{staticClass:"ba-text-uppercase ba-montserrat-bold",attrs:{"to":"/data-user?page=a2p"}},[_vm._v(_vm._s(_vm.$t('ge-click-here')))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }